<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`应付账款`)">导出</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import Wxts from '../../../components/Wxts.vue';
export default {
  mixins: [tableMixin],
  components: { Wxts },
  data() {
    return {
      baseUrl: 'pcustom',
      getListUrl: 'freightrec',
      breadcrumb: [
        { name: "财务管理" },
        { name: "应付账款管理" },
      ],
      wxtsList: [
        {
          name: '待结金额=应付运费总额-已打款金额之和。'
        }
      ],
      formInline: {},
      formCtrl: [
        // {
        //   ...this.ctrls.month
        // },
        {
          label: "公司名称",
          keyName: "company",
          placeholder: "请填写公司名称",
          type: "text",
        },
      ],
      cols: [
        { keyName: "company", label: "公司名称", minwidth: 120 },
        { keyName: "pname", label: "承运联系人", minwidth: 120 },
        { keyName: "phone", label: "联系电话", minwidth: 120 },
        { keyName: "address", label: "地址", minwidth: 120 },
        { keyName: "money", label: "待结金额", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      getTotalProperty: ['money'],
      btns: [
        {
          title: '运单列表',
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ id }) => {
            this.$router.push(
              `/finance/carrierOrder?shipperid=${id}`
            );
          },
        },
        {
          title: '打款记录',
          img: require('@/assets/img/shipper_order_list.png'),
          unimg: require('@/assets/img/shipper_order_list_hover.png'),
          cb: ({ id, pname }) => {
            this.$router.push(
              `/finance/carrierPaymentHistory?shipperid=${id}&pname=${pname}`
            );
          },
        },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style scoped></style>